import { render, staticRenderFns } from "./QScoreCardSME.vue?vue&type=template&id=39882d8e&scoped=true&"
import script from "./QScoreCardSME.vue?vue&type=script&lang=js&"
export * from "./QScoreCardSME.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39882d8e",
  null
  
)

export default component.exports